/**
 * Subscription service for managing Stripe-based subscriptions
 * Handles subscription creation, status checks, and customer portal access
 */

// In production: use relative path (Caddy proxies /api/* to backend)
// In development: use absolute URL (dev server needs to reach backend:5000)
const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

/**
 * Create a Stripe Checkout session for subscription
 * Returns the checkout URL for redirection
 */
export const createSubscription = async (): Promise<{ url: string }> => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Authentication required');
    }

    const response = await fetch(`${API_BASE_URL}/subscription/subscribe`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to create subscription');
    }

    return response.json();
};

/**
 * Get customer portal URL for subscription management
 * Returns the portal URL for redirection
 */
export const getCustomerPortalUrl = async (): Promise<{ url: string }> => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Authentication required');
    }

    const response = await fetch(`${API_BASE_URL}/subscription/customer-portal`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to get customer portal URL');
    }

    return response.json();
};